export default __webpack_public_path__ + "static/media/resources-and-production-6.777e8d91.png";